import React from 'react';
import { SingleProductDetailTable } from './single-product-detail-table';
import './products-details-table.scss';
import { summaryTableMessages } from 'azshared';
import { useIntl } from 'react-intl';
import { PirBoxProductsDetails } from 'azshared/build/main/lib/model/pirbox/pir-box-product-detail';

export const ProductsDetailsTable = (props: { positions: PirBoxProductsDetails[] }) => {
  const { positions } = props;
  const { formatMessage } = useIntl();

  return (
    <div className='products-table-container'>
      {positions && positions.length > 0 ? (
        <>
          {positions
            .filter((position) => position.activity?.length)
            .map((position) => (
              <SingleProductDetailTable key={position.codTitle} position={position} />
            ))}
          <p>{formatMessage(summaryTableMessages.disclaimer1)}</p>
          <p>{formatMessage(summaryTableMessages.disclaimer2)}</p>
        </>
      ) : (
        <p>{formatMessage(summaryTableMessages.noProductAvailable)}</p>
      )}
    </div>
  );
};
